// extracted by mini-css-extract-plugin
export default {"table":"table_table__XLlM1","tableHeader":"table_tableHeader__Hmf25","handleSort":"table_handleSort__XWl-1","active":"table_active__jkOKZ"};